/**
 * 카드받기 현황 (/adm/cardpay) — 가맹점 · 결제 · 구 카드내역(페이엣) 탭
 * ($j.Pages.Admin.CardPay / body data-page-name="CardPay"). 구 카드내역 탭은 F/Admin/CardPay/Legacy
 */
import CardPayLegacy from '../../F/Admin/CardPay/Legacy';

export default class CardPay {
    initialize() {
        const legacy = new CardPayLegacy();
        const PAGE_SIZE = 20;
        let currentTab = 'pay';
        let currentStatus = { shops: '', pay: '' };
        let currentPage = { shops: 1, pay: 1 };
        let currentShopMbNo = null; // 가맹점 상세 모달에 열려있는 회원번호 (메모 추가·불러톡·결제내역이 이걸 본다)
        let currentShopName = '';
        let currentItem = null; // 결제 상세 모달에 로드된 항목 (전표가 이걸 본다)
        let searchTimer = null;

        const STATUS_OPTIONS = {
            shops: [
                { value: '',        text: '전체' },
                { value: 'PENDING', text: '가입신청' },
                { value: 'ACTIVE',  text: '사용중' },
                { value: 'FAILED',  text: '실패' },
            ],
            pay: [
                { value: '',         text: '전체' },
                { value: 'PENDING',  text: '대기' },
                { value: 'PAID',     text: '승인' },      // 승인됐고 아직 정산 전 (화면 상태 — CardPaymentService::viewStatus)
                { value: 'SETTLED',  text: '완료' },      // 승인건 중 정산일이 지난 것
                { value: 'CANCELED', text: '취소' },
                { value: 'FAILED',   text: '실패' },
            ],
        };

        function init() {
            // 검색칸은 글자마다 조회하지 않는다 — 자동완성에서 고르거나 엔터를 칠 때, 그리고 칸을 비웠을 때만 다시 찾는다
            $j.F.Admin.Util.memberSearch('find-user-kwd', () => reload(currentTab));
            $j.F.Admin.Util.memberSearch('find-user-kwd-pay', () => reload(currentTab));
            $('#find-user-kwd, #find-user-kwd-pay, #kwd-pay')
                .on('keydown', function (e) { if (e.key === 'Enter') reload(currentTab); })
                .on('input', function () {
                    clearTimeout(searchTimer);
                    if (this.value.trim() === '') searchTimer = setTimeout(() => reload(currentTab), 300);
                });
            $('#period-shops, #period-pay, #purpose-pay, #pgco-pay').on('change', () => reload(currentTab));
            // 검색칸 ✕ — 검색어가 있을 때만 보이고, 누르면 그 칸만 비우고 첫 쪽부터 다시 받는다
            $('.fsearch-x').each(function () {
                const $x = $(this), $in = $('#' + $x.data('for'));
                $in.on('input', function () { $x.prop('hidden', !this.value); });
                $x.on('click', () => { $in.val('').trigger('focus'); reload($x.data('pane')); });
            });
            $(document).on('click', '#pg-shops .me-pg__btn, #pg-pay .me-pg__btn', function () {
                const pane = $(this).closest('#pg-shops').length ? 'shops' : 'pay';
                currentPage[pane] = Number($(this).data('page')) || 1;
                load(pane);
            });

            renderChips('shops', {});
            renderChips('pay', {});
            // 기본 탭 = 결제 (가입신청 대기가 있어도 항상 결제부터). ?tab= 로 다른 탭을 열 수 있다 — 예전 /adm/card/payments 는 ?tab=legacy 로 온다
            const tab = new URLSearchParams(location.search).get('tab');
            if (tab === 'shops' || tab === 'legacy') manageTab(tab); else load('pay');
            // 탭 머리 숫자는 그 탭 목록을 불러올 때 채워진다 — 안 연 탭도 처음부터 건수가 뜨게 같이 불러둔다
            if (tab === 'shops' || tab === 'legacy') loadPays();
            if (tab !== 'shops') loadShops();
            if (tab !== 'legacy') legacy.count();
        }

        const manageTab = function (pane) {
            currentTab = pane;
            $('#cpTabs .ftab').removeClass('on').filter('[data-pane="' + pane + '"]').addClass('on');
            $('.mpane').removeClass('on');
            $('#mp-' + pane).addClass('on');
            load(pane);
        };

        /** 기간선택 → 실제 조회기간 */
        function currentDates(pane) {
            const today = dayjs();
            const val = $('#period-' + pane).val();
            let start, end;
            switch (val) {
                case 'today':     start = today; end = today; break;
                case 'week':      start = today.startOf('week'); end = today; break;
                case 'month':     start = today.startOf('month'); end = today; break;
                case 'lastmonth': { const lm = today.subtract(1, 'month'); start = lm.startOf('month'); end = lm.endOf('month'); break; }
                case 'all':       start = dayjs('2016-01-01'); end = today; break;
                default:          start = today.subtract(3, 'month'); end = today; break; // '3m'
            }
            return { start: start.format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD') };
        }

        /** counts 값은 탭마다 모양이 다르다 — 가맹점은 순수 개수, 결제는 {cnt,amt}(statusTotals 참고) */
        function statusCount(v) { return v && typeof v === 'object' ? (v.cnt || 0) : (v || 0); }

        function renderChips(pane, counts) {
            const $wrap = $('#chips-' + pane).empty();
            STATUS_OPTIONS[pane].forEach((o) => {
                const cnt = o.value === ''
                    ? Object.values(counts).reduce((s, v) => s + statusCount(v), 0)
                    : statusCount(counts[o.value]);
                $('<button type="button" class="chip"></button>')
                    .toggleClass('on', currentStatus[pane] === o.value)
                    .text(o.text + ' ')
                    .append($('<span class="c"></span>').text(cnt))
                    .on('click', () => { currentStatus[pane] = o.value; reload(pane); })
                    .appendTo($wrap);
            });
        }

        /** 결제 상태별 {cnt,amt} 총합 — statusCounts 응답 그대로에서 뽑는다 */
        function statusTotals(counts) {
            let cnt = 0, amt = 0;
            Object.values(counts).forEach((v) => { cnt += v.cnt || 0; amt += v.amt || 0; });
            return { cnt, amt };
        }

        function load(pane) {
            if (pane === 'shops') loadShops();
            else if (pane === 'legacy') legacy.load();
            else loadPays();
        }
        /** [검색] 버튼 — 검색칸 Enter 와 같다(그 탭의 검색칸·조건 전부로 첫 쪽부터) */
        const cpSearch = function (pane) { reload(pane); };

        /** 검색칸 ✕ 표시 맞추기 — 자동완성이 칸을 채우면 input 이벤트가 없어 목록을 받을 때 다시 본다 */
        function syncSearchX(pane) {
            $('.fsearch-x[data-pane="' + pane + '"]').each(function () {
                $(this).prop('hidden', !$('#' + $(this).data('for')).val());
            });
        }

        /** 조건이 바뀌면 첫 쪽부터 */
        function reload(pane) {
            if (currentPage[pane]) currentPage[pane] = 1;
            load(pane);
        }
        function renderPager(pane, total) {
            $('#pg-' + pane).html($j.F.Admin.Util.pager({ page: currentPage[pane], pages: Math.ceil(total / PAGE_SIZE), total }));
        }

        function loadShops() {
            const range = currentDates('shops');
            syncSearchX('shops');
            $.post('/adm/ajax/cardpay/merchants', {
                start: (currentPage.shops - 1) * PAGE_SIZE, length: PAGE_SIZE,
                statusFilter: currentStatus.shops,
                findUserKwd: $('#find-user-kwd').val(),
                start_date: range.start, end_date: range.end,
            }, function (res) {
                const counts = res.statusCounts || {};
                $('#tab-c-shops').text(Object.values(counts).reduce((s, v) => s + statusCount(v), 0).toLocaleString());
                renderChips('shops', counts);
                renderShops(res.data || []);
                renderPager('shops', Number(res.recordsTotal) || 0);
            });
        }

        /** 결제 탭 조건 — 목록·상단 요약·엑셀이 같은 값을 보낸다 */
        function payParams() {
            const range = currentDates('pay');
            return {
                statusFilter: currentStatus.pay,
                purposeFilter: $('#purpose-pay').val(),
                pg: $('#pgco-pay').val(),
                findUserKwd: $('#find-user-kwd-pay').val(),
                keyword: $('#kwd-pay').val().trim(),
                start_date: range.start, end_date: range.end,
            };
        }

        const downloadPayExcel = function () {
            location.href = '/adm/cardpay/payments/excel?' + $.param(payParams());
        };

        function loadPays() {
            const range = currentDates('pay');
            syncSearchX('pay');
            $.post('/adm/ajax/cardpay/payments', Object.assign({
                start: (currentPage.pay - 1) * PAGE_SIZE, length: PAGE_SIZE,
            }, payParams()), function (res) {
                const counts = res.statusCounts || {};
                $('#tab-c-pay').text(Object.values(counts).reduce((s, v) => s + statusCount(v), 0).toLocaleString());
                renderChips('pay', counts);
                renderPays(res.data || []);
                renderPager('pay', Number(res.recordsTotal) || 0);

                // 결제 건수 요약 — 목록은 length 만큼만 오므로 statusCounts(전체 집계)를 정본으로 쓴다.
                // 금액은 취소건을 뺀 승인 합계만 — 취소는 실제로 들어온 돈이 아니다. 승인 = 승인(정산 전) + 정산완료
                const totals = statusTotals(counts);
                const p1 = counts.PAID || { cnt: 0, amt: 0 }, p2 = counts.SETTLED || { cnt: 0, amt: 0 };
                const paid = { cnt: p1.cnt + p2.cnt, amt: p1.amt + p2.amt };
                $('#payCntLbl').text(`${range.start} ~ ${range.end} 결제`);
                $('#payCntVal').text(`${totals.cnt.toLocaleString()}건 · ${won(paid.amt)}`);
                $('#payApprovedCnt').text(`${paid.cnt.toLocaleString()}건`);
                $('#payCanceledCnt').text(`${(counts.CANCELED ? counts.CANCELED.cnt : 0).toLocaleString()}건`);
            });
            loadSummary();
        }

        function esc(s) { return $('<div>').text(s == null ? '' : String(s)).html(); }
        function won(n) { return Number(n || 0).toLocaleString() + '원'; }

        // FAILED — 이노페이가 가입신청을 거절했거나 전송이 실패한 신청(회원은 다시 신청할 수 있다)
        function merchantPill(status) {
            return { ACTIVE: ['p-ok', '사용중'], FAILED: ['p-stop', '실패'] }[status] || ['p-wait', '가입신청'];
        }
        function paymentPill(status) {
            const map = { PENDING: ['p-wait', '대기'], PAID: ['p-ok', '승인'], SETTLED: ['p-done', '완료'], CANCELED: ['p-cancel', '취소'], FAILED: ['p-stop', '실패'] };
            return map[status] || ['p-cancel', status || ''];
        }
        // 유형 칸 — 관리자 모드 결제는 용도(장기선결제·외부배차)를, 일반 카드결제는 연결유형(단건·묶음·직접)을 보인다
        // legacy = 구 페이앳에서 옮겨온 결제 — 이노페이 결제와 한 목록에 섞여 나오므로 앞에 '구 페이앳'을 붙인다
        // compact — 목록용. 대부분인 단건은 빼고 묶음·직접만, 구 페이앳은 '구' 한 글자(상세는 다 적는다).
        //   '구' 자리와 유형 자리를 폭 고정 두 칸(.tb-slots)에 넣어 행마다 같은 위치에 선다 — 없으면 빈 칸으로 자리만 둔다
        function typeBadge(type, purpose, legacy, compact = false) {
            let kind = '';
            if (purpose === 'long') kind = '<span class="tbadge tb-long">장기선결제</span>';
            else if (purpose === 'ext') kind = '<span class="tbadge tb-ext">외부배차</span>';
            else if (type === 'bundle') kind = '<span class="tbadge tb-bundle">묶음</span>';
            else if (type === 'direct') kind = '<span class="tbadge tb-direct">직접</span>';
            else if (!compact) kind = '<span class="tbadge tb-single">단건</span>';

            if (compact) {
                const old = legacy ? '<span class="tb-old" title="구 페이앳">구</span>' : '';
                return `<span class="tb-slots"><span>${old}</span><span>${kind}</span></span>`;
            }
            return (legacy ? '<span class="tbadge tb-single">구 페이앳</span> ' : '') + kind;
        }

        function renderShops(rows) {
            if (!rows.length) { $('#shopBody').html('<tr><td colspan="6" class="qempty">가맹점이 없습니다.</td></tr>'); return; }
            $('#shopBody').html(rows.map((r) => {
                const [tone, label] = merchantPill(r.status);
                const dateLabel = r.status === 'ACTIVE' && r.resolved_at ? ('승인 ' + $j.Common.Util.formatDateTime(r.resolved_at)) : ('신청 ' + $j.Common.Util.formatDateTime(r.applied_at));
                return `<tr class="qrow" data-num="${r.num}">
                    <td><div class="shopn">${esc(r.co_title || '')}</div><div class="subn">#${r.mb_no}</div></td>
                    <td class="mono">${esc(r.co_number || '')}</td>
                    <td>${esc(r.mem_name || '')}</td>
                    <td>${feeGradeHtml(r)}</td>
                    <td><span class="pill ${tone}">${label}</span>${r.status === 'FAILED' && r.fail_reason ? `<div class="subn fail-rsn" title="${esc(r.fail_reason)}">${esc(r.fail_reason)}</div>` : ''}</td>
                    <td class="mono">${dateLabel}</td>
                </tr>`;
            }).join(''));
        }

        function renderPays(rows) {
            payRows = {};
            if (!rows.length) { $('#payBody').html('<tr><td colspan="11" class="qempty">결제 내역이 없습니다.</td></tr>'); return; }
            $('#payBody').html(rows.map((r) => {
                const [tone, label] = paymentPill(r.view_status);
                // 결제자가 가맹점 소유자와 다르면(소속 기사가 받은 결제) 아래 줄에 결제자를 적는다
                const payer = r.payer_name && Number(r.mb_no) !== Number(r.owner_num) ? `<div class="subn">결제 ${esc(r.payer_name)}</div>` : '';
                const orders = (r.orders || []).map(orderLink).join(' ');
                // 수수료·정산액은 승인건만 의미가 있다 — 대기·실패·취소는 비운다
                const paid = r.status === 'PAID';
                payRows[r.num] = r;
                // 취소건은 줄 배경을 회색으로 — 캐시 입출금의 취소 줄과 같은 표기
                return `<tr class="qrow${r.status === 'CANCELED' ? ' is-x' : ''}" data-num="${r.num}">
                    <td class="mono">${$j.Common.Util.formatDateTime(r.created_at)}</td>
                    <td><div class="shopn">${esc(r.owner_name || '')}</div>${payer}</td>
                    <td>${typeBadge(r.type, r.purpose, r.legacy, true)}</td>
                    <td class="mono ctr ord-cell">${orders}</td>
                    <td>${esc(r.addr || '')}</td>
                    <td>${esc(r.card_co || '')}</td>
                    <td class="amt">${won(r.pay_total)}<div class="vat-tag">부가세 ${r.vat_included ? '포함' : '별도'}</div></td>
                    <td class="amt r sub-amt">${paid ? won(r.fee) : ''}</td>
                    <td class="amt r">${paid ? won(r.settle_amt) : ''}</td>
                    <td class="memo-cell">${r.memo_cnt ? `<span class="pm-last">${esc(r.memo)}</span>${r.memo_cnt > 1 ? ` <span class="pm-cnt">${r.memo_cnt}</span>` : ''}` : ''}</td>
                    <td><span class="pill ${tone}">${label}</span>${r.fail_reason ? `<div class="subn gap">${esc(r.fail_reason)}</div>` : ''}${r.status === 'CANCELED' && r.cancel_reason ? `<div class="subn cx-rsn gap" title="${esc(r.cancel_reason)}">${esc(r.cancel_reason)}</div>` : ''}</td>
                </tr>`;
            }).join(''));
        }

        /** 지금 쪽 결제 행(num → 행) — 비고 칸이 열 때 승인번호·기존 메모를 읽는다 */
        let payRows = {};

        /**
         * 결제 탭 '비고' — 칸을 누르면 이 결제건의 관리자 메모 이력(최신순)과 입력칸. 추가·삭제하면 이력과 목록 칸을 다시 그린다.
         * 목록 칸은 최근 메모 한 줄 + 2건 이상이면 건수(CardPayController::getPayments 가 붙인다).
         */
        const cpPayMemo = {
            num: 0,
            changed: false,
            open(num) {
                const r = payRows[num];
                if (!r) return;
                this.num = num;
                this.changed = false;
                $('#pm-title').text(`관리자 메모 · 승인번호 ${r.approval_no || ''}`);
                $('#pm-input').val('');
                $('#pm-list').html('');
                $('#payMemoModal').addClass('on');
                this.reload();
                $('#pm-input').trigger('focus');
            },
            close() {
                $('#payMemoModal').removeClass('on');
                if (this.changed) loadPays();
            },
            reload() {
                $.get(`/adm/ajax/cardpay/payments/${this.num}/memos`, (res) => {
                    const memos = (res && res.memos) || [];
                    $('#pm-list').html(memos.length ? memos.map((m) => `
                        <div class="pm-item">
                            <div class="pm-meta">${esc(m.writer_name || ('#' + m.mb_no))} · ${esc((m.datetime || '').substr(0, 16))}
                                <button type="button" class="pm-del" data-memo="${m.num}" title="삭제">✕</button></div>
                            <div class="pm-text">${esc(m.memo || '')}</div>
                        </div>`).join('') : '<div class="pm-empty">메모가 없습니다.</div>');
                }, 'json');
            },
            add() {
                const memo = $('#pm-input').val().trim();
                if (!this.num || memo === '') return;
                $.post(`/adm/ajax/cardpay/payments/${this.num}/memo`, { memo }, (res) => {
                    if (!res.result) { $j.Common.Util.swalert(res.message || '메모 저장에 실패했습니다.'); return; }
                    $('#pm-input').val('');
                    this.changed = true;
                    this.reload();
                }, 'json');
            },
            remove(memoNum) {
                $j.Common.Util.swalert('이 메모를 삭제할까요?', () => {
                    $.post(`/adm/ajax/cardpay/payments/${this.num}/memo/${memoNum}/delete`, (res) => {
                        if (!res.result) { $j.Common.Util.swalert(res.message || '삭제하지 못했습니다.'); return; }
                        this.changed = true;
                        this.reload();
                    }, 'json');
                });
            },
        };

        /* ── 정산 요약 스트립 ─────────────────────────────────────── */
        function loadSummary() {
            $.post('/adm/ajax/cardpay/payments/summary', payParams(), function (res) {
                $('#sumPending').text(won(res.pendingSettle));
                $('#sumDone').text(won(res.doneSettle));
                $('#sumFee').text(won(res.feeTotal));
                $('#sumProfit').text(won(res.companyProfit));
            });
        }

        /**
         * 수수료 구간표 이미지 다운로드 — 기사님께 보낼 용도라 '구간(등급)'·'가맹점 수수료(기사님)' 두 칸만 담는다
         * (이노페이·카드사 몫과 자사 수익은 빼고). 값은 화면 표(#feeTableWrap)에서 읽는다 — 요율을 두 곳에 두지 않는다.
         * 캡처 이미지는 관리자 화면모드(다크)와 무관하게 흰 바탕 문서로 그린다.
         */
        const downloadFeeTable = function () {
            const rows = $('#feeTableWrap tbody tr').map(function () {
                const $td = $(this).children('td');
                return { grade: $td.eq(0).text().trim(), rate: $td.eq(1).text().trim() };
            }).get();
            if (!rows.length) return;

            // 캡처 틀 모양은 _cardpay.scss 의 .cp-feecap (body 직속이라 #cpRoot 밖 규칙)
            const body = rows.map((r) => '<tr><td class="g">' + $('<i>').text(r.grade).html() + '</td>'
                + '<td class="r">' + $('<i>').text(r.rate).html() + '</td></tr>').join('');
            const $cap = $('<div class="cp-feecap">'
                + '<div class="t">카드결제 수수료 구간표</div>'
                + '<table><thead><tr>'
                + '<th>구간(등급)</th><th class="r">가맹점 수수료(기사님)</th>'
                + '</tr></thead><tbody>' + body + '</tbody></table></div>').appendTo('body');

            loadHtml2Canvas()
                .then(() => window.html2canvas($cap[0], { scale: 2, backgroundColor: '#ffffff', logging: false }))
                .then((canvas) => {
                    const a = document.createElement('a');
                    a.href = canvas.toDataURL('image/png');
                    a.download = '카드결제_수수료_구간표.png';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                })
                .catch(() => toast('이미지를 만들지 못했습니다.'))
                .finally(() => $cap.remove());
        };

        /** html2canvas 지연 로드 — 전표 공유(F/Admin/CardPay/ReceiptShare)와 같은 파일·같은 표식이라 두 번 싣지 않는다 */
        function loadHtml2Canvas() {
            return new Promise((resolve, reject) => {
                if (window.html2canvas) return resolve();
                let s = document.querySelector('script[data-rc-h2c]');
                if (s) { s.addEventListener('load', () => resolve()); s.addEventListener('error', reject); return; }
                s = document.createElement('script');
                s.src = '/js/vendor/html2canvas.1.4.1.min.js';
                s.setAttribute('data-rc-h2c', '1');
                s.onload = () => resolve();
                s.onerror = reject;
                document.head.appendChild(s);
            });
        }

        const toggleFee = function () {
            // .card 는 flex 라 show()/toggle() 대신 클래스로 연다
            const $wrap = $('#feeTableWrap');
            const open = !$wrap.hasClass('cp-off');
            $wrap.toggleClass('cp-off', open);
            $('#feeToggleLbl').text(open ? '펼치기' : '접기');
            $('#feeToggleChev').text(open ? '▾' : '▴');
        };

        /** 수수료 등급 — 등급(영세·중소·일반)과 이노페이가 알려준 요율. 승인 전이면 빈칸 */
        function feeGradeHtml(r) {
            if (!r.fee_grade && r.card_fee == null) return '';
            const rate = r.card_fee != null ? ` <span class="subn">${+Number(r.card_fee).toFixed(2)}%</span>` : '';
            return (r.fee_grade ? `<span class="grade">${esc(r.fee_grade)}</span>` : '') + rate;
        }

        /* ── 가맹점 상세 — 목록 칸 + 정산계좌·서류를 서버에서 다시 받는다 ──────────── */
        const cpOpenShop = function (num) {
            $.post('/adm/ajax/cardpay/merchants/detail', { num }, function (res) {
                if (!res.success) { toast(res.message || '조회에 실패했습니다.'); return; }
                renderShopDetail(res.item);
            });
        };

        function renderShopDetail(r) {
            const [tone, label] = merchantPill(r.status);
            const isActive = r.status === 'ACTIVE';
            const isFail = r.status === 'FAILED';

            $('#sv-pill').removeClass().addClass('pill ' + tone).text(label);
            $('#sv-shop').text(r.co_title || '');
            $('#sv-mid').text(r.mid || '');
            $('#sv-hint').text(isActive
                ? '카드결제를 정상 사용 중입니다.'
                : isFail
                    ? '가입 신청이 이노페이에서 거절됐거나 전송에 실패했습니다. 회원이 서류를 고쳐 다시 신청할 수 있습니다.'
                    : '서류를 이노페이로 넘겨 심사 중입니다. 승인되면 자동으로 사용중이 되고 알림이 발송됩니다.');
            $('#sv-steps').html(isFail ? `
                <div class="step"><span class="sn">✓</span>가입신청</div>
                <span class="arrow">›</span>
                <div class="step cur fail"><span class="sn">✕</span>실패</div>
            ` : `
                <div class="step ${isActive ? '' : 'cur'}"><span class="sn">${isActive ? '✓' : '1'}</span>가입신청</div>
                <span class="arrow">›</span>
                <div class="step ${isActive ? 'cur' : 'todo'}"><span class="sn">${isActive ? '✓' : '2'}</span>승인·사용중</div>
            `);
            $('#kv-fail-k, #kv-fail').prop('hidden', !isFail);
            $('#kv-fail').text(r.fail_reason || '사유 기록 없음 — 통신로그(/adm/vendor-logs, innopay_contract)에서 확인');

            $('#kv-shop').text(r.co_title || '');
            $('#kv-biz').text(r.co_number || '');
            $('#kv-ceo').text(r.co_ceoname || '');
            // 가맹점 연락처·주소는 가입신청서에 적은 값이다(회원 업체정보와 다를 수 있다)
            $('#kv-cophone').text(r.co_phone || '');
            $('#kv-coaddr').text(r.co_address || '');
            $('#kv-fee').html(feeGradeHtml(r));
            // 정산계좌는 신청서 값 — 그 칸이 생기기 전 신청건만 회원 업체정보 계좌라 출처를 같이 적는다
            $('#kv-acct').html(r.settle_bank
                ? `${esc(r.settle_bank)} <span class="subn">예금주 ${esc(r.settle_holder || '')}${r.settle_from === 'company' ? ' · 회원 업체정보 기준(신청서 계좌 없음)' : ''}</span>`
                : '');
            // 서류는 있는지만 보인다 — 원본 링크는 걸지 않는다
            $('#kv-docs').html((r.docs || []).map((d) => d.url
                ? esc(d.label)
                : `<span class="subn">${esc(d.label)} ${d.has ? '(사진 없음)' : '없음'}</span>`).join(' · ') || '');
            $('#kv-mem').html(`<a href="javascript:void(0)" class="cp-portal" data-mb="${r.mb_no}" data-path="/m/cardpay">${esc(r.mem_name || '')} (#${r.mb_no})</a>`);
            $('#kv-phone').text(r.mem_phone || '');
            $('#kv-applied').html(r.applied_at ? $j.Common.Util.formatDateTime(r.applied_at) : '');
            $('#kv-resolved').html(r.resolved_at ? $j.Common.Util.formatDateTime(r.resolved_at) : '');

            currentShopMbNo = r.mb_no;
            currentShopName = r.mem_name || '';
            $('#sv-memo-input').val('');
            loadShopMemos(r.mb_no);

            $('#shopModal').addClass('on');
        }
        const closeShop = function () { $('#shopModal').removeClass('on'); };

        /** 가맹점 소유자에게 불러톡 — 가입 실패 안내 등. 관리자 불러톡 팝업(회원 방) */
        const shopChat = function () {
            if (currentShopMbNo) $j.F.Admin.Util.chat(currentShopMbNo);
        };

        /** 이 가맹점의 결제내역 — 결제 탭을 '이름#번호'·전체 기간으로 연다(소유자로 찾으면 소속 기사 결제까지 나온다) */
        const shopPayments = function () {
            if (!currentShopMbNo) return;
            closeShop();
            $('#find-user-kwd-pay').val(`${currentShopName}#${currentShopMbNo}`);
            $('#kwd-pay').val('');
            $('#period-pay').val('all');
            $('#purpose-pay').val('');
            $('#pgco-pay').val('');
            currentStatus.pay = '';
            currentPage.pay = 1;
            manageTab('pay');
        };

        /* ── 처리 메모 — 새 테이블 아님, 기존 회원 상담내역(g5_member_counsels)을 type='카드'로 재사용 ── */
        function loadShopMemos(mbNo) {
            $.post(`/adm/ajax/member/${mbNo}/counsels`, { type: '카드' }, function (res) {
                const rows = res.data || [];
                $('#sv-memolist').html(rows.length ? rows.map((m) => `
                    <div class="memo">
                        <span class="ml">카드</span>
                        <span class="mm">${esc(m.manage_name || '')} · ${esc((m.counsel_date || '').slice(0, 10))}</span>${esc(m.content || '')}
                    </div>
                `).join('') : '<div class="hint flush">등록된 메모가 없습니다.</div>');
            });
        }

        const addShopMemo = function () {
            const $input = $('#sv-memo-input');
            const content = $input.val().trim();
            if (!content || !currentShopMbNo) return;

            $.post(`/adm/ajax/member/${currentShopMbNo}/counsel/add`, { type: '카드', content }, function (res) {
                if (res.result) {
                    $input.val('');
                    loadShopMemos(currentShopMbNo);
                } else {
                    toast(res.message || '메모 추가에 실패했습니다.');
                }
            });
        };

        /* ── 결제 상세 ────────────────────────────────────────────── */
        const cpOpenPay = function (num) {
            $.post('/adm/ajax/cardpay/payments/detail', { num }, function (res) {
                if (!res.success) { toast(res.message || '조회에 실패했습니다.'); return; }
                currentItem = res.item;
                renderPaymentDetail(currentItem);
                $('#payModal').addClass('on');
            });
        };
        const closePay = function () { $('#payModal').removeClass('on'); };

        function renderPaymentDetail(item) {
            const total = item.amt + item.vat;
            const [statTone, statText] = paymentPill(item.viewStatus);

            // 상단 이름(가맹점 소유자) → 기사관리 창. 가맹가입 상세의 #kv-mem 과 같은 입구다. 소유자를 못 찾은 옛 결제는 결제자로 연다
            const shopNo = item.ownerNo || item.mbNo;
            $('#pv-shop').html(shopNo
                ? `<a href="javascript:void(0)" class="cp-portal" data-mb="${Number(shopNo)}">${esc(item.ownerName || item.payerName || '')}</a>`
                : esc(item.ownerName || ''));
            $('#pv-pill').removeClass().addClass('pill ' + statTone).text(statText);
            $('#pv-typebadge').html(typeBadge(item.payType, item.purpose, item.legacy));
            $('#pv-no').text(item.id);
            $('#pv-an').text(item.approvalNo || '');
            $('#pv-dt').text(item.payDate || '');
            $('#pv-stat').text(statText + ' / ' + item.quotaText);
            $('#pv-payer').text(item.payerName || '');
            $('#pv-card').text(item.cardCo || '');

            $('#pv-works').html(paymentWorksHtml(item));
            $('#pv-workcnt').text(item.works.length > 1 ? `묶음 ${item.works.length}건` : '단건 1건');

            $('#pv-work').text(won(item.amt));
            $('#pv-vat').text(won(item.vat));
            $('#pv-total').text(won(total));
            // 결제 당시 등급 요율 (shapeItem 이 항상 채운다). 페이앳 이관건(고정 2.5%)은 수수료 VAT 를 따로 안 붙여 'VAT 포함'
            $('#pv-rate').text('(' + +(item.feeRate * 100).toFixed(2) + '%, VAT ' + (item.legacy ? '포함' : '별도') + ')');
            // item.fee = 수수료 + 수수료 VAT — 회원 화면(CardPay.js feeRowsHtml)처럼 한 줄 합계. 정산 받은 건은 이노페이 실제 값이라 '입금액', 전은 '예상 입금액'
            $('#pv-fee').text('-' + won(item.fee));
            $('#pv-net-k').text(item.settled ? '입금액' : '예상 입금액');
            $('#pv-net').text(item.x ? '-' : won(item.settleAmt));   // 취소된 결제는 입금이 없다
            $('#pv-acct').html(item.settleBank ? `${esc(item.settleBank)}<span class="acct-holder">예금주 ${esc(item.settleHolder || '')}</span>` : '');

            $('#pv-shopn').text(item.merchant.name || '');
            $('#pv-biz').text(item.merchant.bizNo || '');
            $('#pv-ceo').text(item.merchant.ceo || '');
            $('#pv-mid').text(item.mid || '');
            $('#pv-mph').text(item.merchant.phone || '');
            $('#pv-maddr').text(item.merchant.addr || '');

            $('#pv-cancelinfo').prop('hidden', !item.x);
            if (item.x) { $('#pv-crsn').text(item.cancelReason || ''); $('#pv-cdt').text(item.cancelDate || ''); $('#pv-cby').text(item.cancelByName || '-'); }
            const isFail = item.status === 'FAILED';
            $('#pv-failinfo').prop('hidden', !isFail);
            if (isFail) { $('#pv-frsn').text(item.failReason || '사유 없음'); $('#pv-fdt').text(item.failedAt ? $j.Common.Util.formatDateTime(item.failedAt) : ''); }
            $('#pv-rctabs').prop('hidden', !item.x);
            showReceipt(item.x ? 'cancel' : 'pay');   // 취소건은 취소전표부터
            $('#pv-note').text(isFail ? '승인되지 않은 결제입니다.' : item.x ? '이미 취소된 결제입니다.' : '');
        }

        // 오더번호 — 누르면 오더 관리 팝업(admin.js openOrderHandle). 건마다 별도 창으로 띄워 묶음을 나란히 본다.
        function orderLink(on) {
            return on ? `<a href="javascript:void(0)" class="wno" data-order="${on}">#${on}</a>` : '';
        }

        function paymentWorksHtml(item) {
            if (item.direct) {
                return `<div class="workitem">
                    <div class="wtop"><span class="weq">직접입력</span><span class="sp"></span><span class="wamt">${won(item.amt)}</span></div>
                    <div class="wsub">${esc(item.addr || '')}</div>
                    ${item.memo ? `<div class="wmeta">📝 ${esc(item.memo)}</div>` : ''}
                </div>`;
            }
            if (item.works.length > 1) {
                return item.works.map((w) => `<div class="workitem">
                    <div class="wtop">${orderLink(w.orderId)}<span class="weq">${esc(w.eq)}</span><span class="sp"></span><span class="wamt">${won(w.amt + w.vat)}</span></div>
                    <div class="wsub">${esc(w.addr || '')}</div>
                    <div class="wmeta">${esc(item.workDate || '')}${w.time ? ' ' + esc(w.time) : ''}${w.type ? ' · ' + esc(w.type) : ''}</div>
                </div>`).join('');
            }
            return `<div class="workitem">
                <div class="wtop">${orderLink(item.orderId)}<span class="weq">${esc(item.eq || '작업')}</span><span class="sp"></span><span class="wamt">${won(item.amt)}</span></div>
                <div class="wsub">${esc(item.addr || '')}</div>
                <div class="wmeta">${esc(item.workDate || '')}${item.time ? ' ' + esc(item.time) : ''}${item.type ? ' · ' + esc(item.type) : ''}</div>
            </div>`;
        }

        /* ── 매출전표 ─────────────────────────────────────────────── */
        // 결제 상세 오른쪽(#pv-receipt)에 바로 그린다(renderPaymentDetail).
        // 취소건은 위 탭(#pv-rctabs)으로 결제전표·취소전표 중 한 장을 고른다. 저장도 지금 보이는 한 장이다
        let receiptTab = 'pay';
        function showReceipt(tab) {
            receiptTab = (tab === 'cancel' && currentItem && currentItem.x) ? 'cancel' : 'pay';
            $('#pv-rctabs .rc-tab').each(function () { $(this).toggleClass('on', $(this).data('rc') === receiptTab); });
            $('#pv-receipt').html(receiptBody(currentItem));
        }
        $(document).on('click', '#pv-rctabs .rc-tab', function () { showReceipt($(this).data('rc')); });
        function receiptBody(item) {
            return receiptHtml(item, receiptTab === 'cancel');
        }
        /** 전표 1장 — 회원 앱과 같은 공용 전표($j.F.CardReceipt). 가맹점 정보는 item.merchant */
        function receiptHtml(item, isC) {
            return $j.F.CardReceipt.build(item, { cancel: isC });
        }

        /**
         * 전표 이미지 저장 — 결제 상세 오른쪽 전표 아래 버튼이 부른다. 화면 전표와 같은 receiptBody 로
         * 화면 밖(#cpRoot 안 — .rc-* 스타일이 먹는 자리)에 펼쳐 찍는다(취소건이면 탭에서 고른 한 장).
         * 전표는 종이색(--cp-paper-*)으로 고정이라 관리자 다크모드와 무관하게 같은 문서로 나온다.
         * 캡처한 이미지는 base64(data URI) 그대로 내려받는다 — 서버·이미지 서버에 올리지 않는다.
         */
        const saveReceipt = function () {
            if (!currentItem) return;
            const $btn = $('.rc-save');
            if ($btn.first().prop('disabled')) return;
            $btn.prop('disabled', true);

            const $cap = $('<div class="rc-cap"></div>')   // 캡처 틀(_cardpay.scss .rc-cap) — 글자는 안의 .receipt 가 정한다
                .append($('<div class="receipt"></div>').html(receiptBody(currentItem)))
                .appendTo('#cpRoot');
            const name = '매출전표_' + (currentItem.approvalNo || currentItem.moid || 'receipt') + (receiptTab === 'cancel' ? '_취소' : '') + '.png';

            loadHtml2Canvas()
                .then(() => window.html2canvas($cap[0], { scale: 2, backgroundColor: '#ffffff', logging: false }))
                .then((canvas) => {
                    const a = document.createElement('a');
                    a.href = canvas.toDataURL('image/png');
                    a.download = name;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                })
                .catch(() => toast('이미지를 만들지 못했습니다.'))
                .finally(() => { $cap.remove(); $btn.prop('disabled', false); });
        };

        // [개발서버 전용 예시] /adm/cardpay?demo=cancel — 취소건 상세를 가짜 데이터로 띄운다(DB 에 없는 건, 공유 불가)
        if ($('#cpRoot').data('debug') && new URLSearchParams(location.search).get('demo') === 'cancel') {
            currentItem = {
                id: 0, status: 'CANCELED', viewStatus: 'CANCELED', x: true, legacy: false, direct: false,
                payType: 'single', purpose: 'card', approvalNo: '30012345', moid: 'DEMO-CANCEL',
                payDate: '2026-10-15 10:12:31', cancelDate: '2026-10-15 14:40:05', cancelReason: '작업 취소로 고객 요청 (예시)', cancelByName: '홍길동',
                quotaText: '일시불', cardCo: '신한카드', payerName: '홍길동', ownerName: '홍길동', ownerNo: 0, mbNo: 0,
                orderId: 0, eq: '스카이 45m', addr: '경기 성남시 분당구 판교역로 235', workDate: '2026-10-15', time: '09:00', type: '하루',
                works: [], amt: 400000, vat: 40000, fee: 7744, feeVat: 704, feeRate: 0.016,
                settleBank: '신한 110-123-456789', settleHolder: '홍길동', mid: 'demo000001m',
                merchant: { name: '홍길동크레인', bizNo: '123-45-67890', ceo: '홍길동', phone: '010-1234-5678', addr: '경기 성남시 분당구 판교역로 235' },
            };
            renderPaymentDetail(currentItem);
            $('#payModal').addClass('on');
        }

        function toast(m) { $j.Ui.Toast.show(m); }

        /* ── 이벤트 — blade 의 onclick 을 옮겼다 ──────────────────────── */
        $('#cpTabs').on('click', '.ftab', function () { manageTab($(this).data('pane')); });
        $('#cpRoot .btn-search').on('click', function () { cpSearch($(this).data('pane')); });
        $('#feeToggleBtn').on('click', toggleFee);
        $('#feeTableWrap .fee-dl').on('click', downloadFeeTable);
        $('#payExcelBtn').on('click', downloadPayExcel);
        $('#pm-add').on('click', () => cpPayMemo.add());
        $('#pm-list').on('click', '.pm-del', function () { cpPayMemo.remove($(this).data('memo')); });
        $('#sv-memo-add').on('click', addShopMemo);
        $('#sv-chat').on('click', shopChat);
        $('#sv-pays').on('click', shopPayments);
        $('#payModal .rc-save').on('click', saveReceipt);
        $('#shopBody').on('click', 'tr.qrow', function () { cpOpenShop($(this).data('num')); });
        // 오더번호·비고 칸은 줄 클릭(결제 상세)을 타지 않는다
        $('#payBody')
            .on('click', 'tr.qrow', function (e) {
                if ($(e.target).closest('td.ord-cell, td.memo-cell').length) return;
                cpOpenPay($(this).data('num'));
            })
            .on('click', 'td.memo-cell', function () { cpPayMemo.open($(this).closest('tr').data('num')); });
        $('#cpRoot')
            // 오더번호 — 누르면 오더 관리 팝업. 건마다 별도 창으로 띄워 묶음을 나란히 본다
            .on('click', 'a.wno[data-order]', function (e) {
                e.preventDefault();
                const on = $(this).data('order');
                $j.F.Admin.Util.openOrderHandle(on, { name: 'order_handle_' + on });
            })
            .on('click', 'a.cp-portal', function (e) {
                e.preventDefault();
                $j.F.Admin.Util.memberPortal($(this).data('mb'), $(this).data('path'));
            })
            // 모달 — 바깥(어두운 판)이나 닫기 버튼
            .on('click', '.fmodal', function (e) {
                if (e.target !== this && !$(e.target).closest('[data-act="close"]').length) return;
                ({ payMemoModal: () => cpPayMemo.close(), shopModal: closeShop, payModal: closePay, legacyMemoModal: () => legacy.closeMemo() })[this.id]();
            });

        init();
    }
}
